import * as React from 'react';
import { buildMigrationUrl, clearMigrationSession, hasMigrationToken, isSyncDisabledLogin } from '../MigrationModal/Services/migrationLogin.Service';

/** Data wylaczenia synchronizacji danych. USTAW realna date przed wdrozeniem. */
const SYNC_DISABLED_DATE = '24.08.2026 r.';

type Props = {
  /** E-mail zalogowanego usera - decyduje o widocznosci przycisku (domena wewnetrzna dostaje go zawsze). */
  email: string;
  /** ADMIN zostaje na 1.0 (bez auto-przeniesienia), wiec przycisk do 2.0 dostaje zawsze. */
  isAdmin?: boolean;
};

const containerStyle: React.CSSProperties = {
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  backgroundColor: '#4668fd',
  color: '#ffffff',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  fontFamily: 'system-ui, -apple-system, sans-serif',
  fontSize: '14px',
  lineHeight: 1.4
};

const innerContainerStyle: React.CSSProperties = {
  maxWidth: '1440px',
  margin: '0 auto',
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px'
};

const leftSectionStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
  minWidth: 0
};

const iconStyle: React.CSSProperties = {
  fontSize: '22px',
  flexShrink: 0
};

const detailsStyle: React.CSSProperties = {
  fontSize: '13.5px',
  margin: 0
};

const rightSectionStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0
};

const goButtonStyle: React.CSSProperties = {
  backgroundColor: '#ffffff',
  color: '#4668fd',
  textDecoration: 'none',
  fontSize: '14px',
  fontWeight: 600,
  padding: '8px 18px',
  borderRadius: '4px',
  whiteSpace: 'nowrap'
};

/**
 * Pasek dla KAZDEGO zalogowanego na SellTracking 1.0: informacja, ze synchronizacja danych zostala
 * wylaczona i widoczne sa tylko dane historyczne, z zaleceniem przejscia do 2.0. Niezamykalny.
 * Przycisk "Przejdz do SellTracking 2.0" - gdy user MA konto 2.0 (token), jest z domeny wewnetrznej
 * albo jest ADMIN-em (dla nich przejscie jest opcjonalne, nigdy wymuszone).
 */
const MigrationInfoBanner: React.FC<Props> = ({ email, isAdmin }) => {
  const showButton = hasMigrationToken() || isSyncDisabledLogin(email) || !!isAdmin;

  return (
    <div style={containerStyle} role="status">
      <div style={innerContainerStyle}>
        <div style={leftSectionStyle}>
          <span style={iconStyle} aria-hidden="true">⚠️</span>
          <p style={detailsStyle}>
            Synchronizacja danych dla tej wersji systemu została wyłączona w dniu {SYNC_DISABLED_DATE}.
            Aplikacja prezentuje wyłącznie dane historyczne do tego dnia. Aby mieć dostęp do bieżących
            informacji o flocie i przejazdach, zalecamy korzystanie z nowej wersji aplikacji.
          </p>
        </div>

        {showButton && (
          <div style={rightSectionStyle}>
            <a href={buildMigrationUrl()} style={goButtonStyle} onClick={() => clearMigrationSession()}>
              Przejdź do SellTracking 2.0
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default MigrationInfoBanner;



// WEBPACK FOOTER //
// ./src/components/MigrationInfoBanner/MigrationInfoBanner.Component.tsx